import { TreeNode } from "@/types/tree";
import { UnsplashImage } from "../api/unsplash";

export function isUnsplashImage(image: UnsplashImage): boolean {
  return image.urls.raw.includes("unsplash");
}

export function isPexelsImage(image: UnsplashImage): boolean {
  return image.urls.raw.includes("pexels");
}

export function getUnsplashImageUrlWithWidth(rawUrl: string, width: number): string {
  return `${rawUrl}&w=${width}&dpr=2`;
}

export function getPexelsImageUrlWithWidth(rawUrl: string, width: number): string {
  const url = new URL(rawUrl);
  url.searchParams.set('w', (width * 2).toString()); // double the width for dpr=2 like unsplash
  // Keep the original height ratio by removing h parameter to let Pexels auto-calculate
  url.searchParams.delete('h');
  return url.toString();
}

export function getLikelyWidthForImage(_imageId: TreeNode['id']): number | undefined {

  return 420;

  /* todo, get likely width out of the DOM */

}

export function getOptimalImageUrl(image: UnsplashImage, desiredWidth?: number): string {
  if (isUnsplashImage(image)) {
    if (desiredWidth) {
      return getUnsplashImageUrlWithWidth(image.urls.raw, desiredWidth);
    }
    return image.urls.regular;
  } else if (isPexelsImage(image)) {
    if (desiredWidth) {
      return getPexelsImageUrlWithWidth(image.urls.raw, desiredWidth);
    }
    return image.urls.regular;
  } else {
    // Fallback for unknown sources
    return image.urls.regular;
  }
}


